import { MaterialDetails } from '@/types/Material';
import { ThreeJsMaterial } from '@/types/ThreeJs';

export class MaterialDetailsMapper {
    private static materialDetailsProperties: Array<keyof MaterialDetails> = [
        'id',
        'name',
        'envMapPath',
        'materialJson'
    ];

    static getMaterialDetailsFromData(materialDetails: Array<MaterialDetails | null | undefined>): MaterialDetails[] {
        const safeDetails = (materialDetails || []).filter((m): m is MaterialDetails => !!m);
        MaterialDetailsMapper.checkMaterialData(safeDetails);

        const materials: MaterialDetails[] = safeDetails.map((details) => {
            const { id, name, envMapPath, materialJson } = details;

            return {
                id: id || '',
                name: name || '',
                envMapPath: envMapPath ? `${window.env.VITE_BACK_URL}/downloadSvg?filename=${envMapPath}` : '',
                materialJson: MaterialDetailsMapper.mapThreeJsMaterial(materialJson)
            };
        });

        return materials;
    }

    private static checkMaterialData(materialDetails: MaterialDetails[]): void {
        materialDetails.forEach((material) => {
            MaterialDetailsMapper.materialDetailsProperties.forEach((property) => {
                if (!material || material[property] == null) {
                    console.error(
                        `Property ${property} is missing or undefined in this material detail: ${material?.id}.`
                    );
                }
            });
        });
    }

    private static mapThreeJsMaterial(materialJson: ThreeJsMaterial): ThreeJsMaterial {
        const { side, color, emissive, opacity, transparent, roughness, metalness, ...rest } = materialJson;

        return {
            side: side || undefined,
            color: color || undefined,
            emissive: emissive || undefined,
            opacity: opacity ?? 1,
            transparent: transparent || false,
            roughness: roughness ?? 0,
            metalness: metalness ?? 0,
            ...rest
        };
    }
}
